module.exports = __webpack_public_path__ + "static/kids-hands-c3e3649e4d747a229641354b30bcc597.jpg";